var map = {
	"./de.png": "MyFo",
	"./en.png": "2qIH",
	"./es.png": "POSz",
	"./fr.png": "JMqg",
	"./ja.png": "GpHe",
	"./ko.png": "dGcP",
	"./pt.png": "qnmY",
	"./ru.png": "LYwF",
	"./th.png": "aLsA",
	"./zh-Hant.png": "SQ2Q"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ifsE";